export const UnvisitedSitesHeader = () => {
  return (
    <h2 className="text-primary font-figtreeBold pt-2 max-lg:text-sm">
      Sites Not Visited{" "}
      <span className="text-blue-1 text-[10px]">(Last 30 Days)</span>
    </h2>
  );
};
